import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loading from "../../common/Loading";

import ProcessLine from "./Components/ProcessLine";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStatus } from "../../services/redux/reducers/commonThunk";
import { fetchProcessLines } from "../../services/redux/reducers/processLines/processLines";
import { fetchProcessLineStatus } from "../../services/redux/reducers/processLineStatus/processLineStatus";
import { fetchProcessLineItems } from "../../services/redux/reducers/processLineItems/processLineItems";
import { getProcessLineLastCheckoutAttendanceLogs } from "../../services/api/processLineAttendanceLogs";


const ProcessLines = () => {
    const [processLineLastCheckOutAttendanceLogs, setProcessLineLastCheckOutAttendanceLogs] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const processLinesData = useSelector(state => state.processLines.processLinesData)

    const dispatch = useDispatch()

    useEffect(() => {
        const todayDate = new Date()
        todayDate.setHours(0, 0, 0, 0)
        const processLineItemsParams = {
            date: todayDate.toISOString(),
        }
        dispatch(fetchStatus())
        dispatch(fetchProcessLines())
        dispatch(fetchProcessLineStatus())
        dispatch(fetchProcessLineItems(processLineItemsParams))
        fetchProcessLineLastCheckOutAttendanceLogs()
    }, [])

    const fetchProcessLineLastCheckOutAttendanceLogs = async () => {
        setIsLoading(true)
        const response = await getProcessLineLastCheckoutAttendanceLogs()
        setIsLoading(false)
        
        if (!response.failure) {
            setProcessLineLastCheckOutAttendanceLogs(response.data)
        }
        else {
            return dispatch(raiseToast({ severity: 'error', summary: "Process Line Status", detail: response.data.error, life: 3000 }))
        }
    }

    return (
        <>
            <Loading visible={isLoading} />
            <div>
                {
                    processLinesData.map((eachProcessLine, index) => (
                        <ProcessLine
                            key={index}
                            processLine={eachProcessLine}
                            setIsLoading={setIsLoading}
                            processLineLastCheckOutAttendanceLogs={processLineLastCheckOutAttendanceLogs}
                            setProcessLineLastCheckOutAttendanceLogs={setProcessLineLastCheckOutAttendanceLogs}
                        />
                    ))
                }
            </div>
        </>
    )
}

export default ProcessLines;